export const C_AMBER  = '#E8892A';
export const C_TEAL   = '#4BA5A5';
export const C_PURPLE = '#9B5B8E';
export const C_YELLOW = '#F5C842';
export const C_CORAL  = '#C4503A';
export const C_STEEL  = '#7B9BAF';
export const C_SAND   = '#C4A06A';
export const C_ROSE   = '#D4827A';
export const C_ORANGE = '#E07030';
export const C_SLATE  = '#6B8FA8';
export const PALETTE  = [C_AMBER, C_TEAL, C_PURPLE, C_YELLOW, C_CORAL, C_STEEL, C_SAND, C_ROSE, C_ORANGE, C_SLATE];

export function hexRgb(hex) {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return [r, g, b];
}

export function rgba(hex, a) {
    const [r, g, b] = hexRgb(hex);
    return `rgba(${r},${g},${b},${a})`;
}
